export default "__VITE_ASSET__HvH_kYSm__"